var module = angular.module('main.customerorder');

module.component('caCustomerOrderSearch',{
    templateUrl: 'main/customerorder/customerordersearch/customerordercontent/customerordersearch.cmp.tpl.html',
    bindings: {
        searchTerm: '<',
        onCustomerOrderSelected: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($rootScope, $scope, $state, $stateParams, $translate, CustomerOrderApiService,
    confirmationDialogService, loadSpinnerService) {
    var vm = this;

    //Properties
    vm.filterAll = true;
    vm.filterCreated = true;
    vm.filterPending = true;
    vm.filterDelivered = true;
    vm.filterRested = true;
    vm.filterPayed = true;
    vm.filterCancelled = true;

    //Functions
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.loadCustomerOrders = loadCustomerOrders;

    vm.searchTermChange = searchTermChange;
    vm.searchTermChangeDebounced = _.debounce(searchTermChange, 2000);
    vm.flushDebouncedIfEnterKey = flushDebouncedIfEnterKey;
    vm.filterAllChanged = filterAllChanged;

    vm.selectOrder = selectOrder;

    activate();

    function onInit() {
        vm.customerOrders = [];
        vm.searchTerm = {};
        vm.searchTerm.term = ($stateParams.searchTerm) ? $stateParams.searchTerm : '';
        vm.searchTerm.orderTypes = [];
        vm.searchTerm.locations = [];
        vm.searchTerm.selectedFromLocation = {};
        vm.searchTerm.onlyOrderNumber = true;

        vm.currentPage = 1;
        vm.totalItems = 0;
        vm.itemsPerPage = 15;
    }
    function onChanges() {
    }

    function activate() {
        loadLocations();
    }

    function loadCustomerOrders() {
        loadSpinnerService.start('mainSpinner');
        setSearchTermOrderTypes()
        CustomerOrderApiService.getAll(vm.currentPage, vm.searchTerm, vm.itemsPerPage).then(function (response) {
            vm.customerOrders = response.data;
            vm.totalItems = response.totalItems;
            console.log(vm.customerOrders);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function filterAllChanged(){
        vm.filterCreated = vm.filterAll;
        vm.filterPending = vm.filterAll;
        vm.filterDelivered = vm.filterAll;
        vm.filterRested = vm.filterAll;
        vm.filterPayed = vm.filterAll;
        vm.filterCancelled = vm.filterAll;

        searchTermChange();
    }

    function setSearchTermOrderTypes(){
        vm.searchTerm.orderTypes = []
        vm.filterAll = true;

        if(vm.filterCreated)
            vm.searchTerm.orderTypes.push('Created');
        else
            vm.filterAll = false;

        if(vm.filterPending)
            vm.searchTerm.orderTypes.push('Pending');
        else
            vm.filterAll = false;
        
        if(vm.filterDelivered)
            vm.searchTerm.orderTypes.push('Delivered');
        else
            vm.filterAll = false;
        
        if(vm.filterRested)
            vm.searchTerm.orderTypes.push('Rested');
        else
            vm.filterAll = false;
        
        if(vm.filterPayed)
            vm.searchTerm.orderTypes.push('Payed');
        else
            vm.filterAll = false;
        
        if(vm.filterCancelled)
            vm.searchTerm.orderTypes.push('Cancelled');
        else
            vm.filterAll = false;

    }

    function loadLocations() {
        loadSpinnerService.start('mainSpinner');
        CustomerOrderApiService.getLocations().then(function (response) {
            vm.locations = response.data.results;
            var newEmptyLocation = {
                id: -1,
                locationName: $translate.instant('common.allLocations')
            };
            vm.locations.unshift(newEmptyLocation);
            vm.searchTerm.selectedFromLocation = vm.locations[0];

            $scope.$watch(function () {
                return vm.searchTerm.selectedFromLocation ? vm.searchTerm.selectedFromLocation.id : undefined;
            }, function(oldValue, newValue) {
                if (oldValue !== newValue || newValue === -1) {
                    searchTermChange();
                }
            });
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadCustomerOrders();
    }

    function flushDebouncedIfEnterKey(keycode) {
        if (keycode ===  13) {
            vm.searchTermChangeDebounced.flush();
        }
    }

    function selectOrder(orderId) {
        vm.onCustomerOrderSelected({ orderId: orderId });
    }
}
